export class GoogleWorkspaceUserMailEntireMailboxOptions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "targetMailbox",
            "baseName": "targetMailbox",
            "type": "string",
            "format": ""
        },
        {
            "name": "label",
            "baseName": "label",
            "type": "string",
            "format": ""
        },
        {
            "name": "restoreOriginalLabels",
            "baseName": "restoreOriginalLabels",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GoogleWorkspaceUserMailEntireMailboxOptions.attributeTypeMap;
    }
    constructor() {
    }
}
